import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapp = styled("div")<{ $color: string }>(({ $color }) => ({
  width: 378,
  height: 618,
  borderRadius: 16,
  background: $color,
  color: "#808080",
  border: `1px solid ${palette.grey200}`,
}))

export const Top = styled("div")<{ $color: string }>(({ $color }) => ({
  padding: 16,
  background: $color,
  borderRadius: 16,
}))

export const TitleWrapp = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  marginBottom: 10,
}))

export const Title = styled("div")(() => ({
  paddingLeft: 12,
  fontSize: 14,
  lineHeight: "24px",
}))

export const CurrencyInput = styled("div")<{
  $color: string
  $borderColor: string
}>(({ $color, $borderColor }) => ({
  display: "flex",
  borderRadius: 8,
  boxSizing: "border-box",
  border: `1px solid ${$borderColor}`,
  backgroundColor: $color,
}))

export const CurrencyInputLeft = styled("div")<{ $borderColor: string }>(
  ({ $borderColor }) => ({
    padding: "12px 16px 12px 20px",
    position: "relative",
    width: "100%",

    "&:after": {
      content: '""',
      position: "absolute",
      width: 1,
      height: 56,
      top: 12,
      right: 0,
      backgroundColor: $borderColor,
    },
  })
)

export const CurrencyInputLabel = styled("div")(() => ({
  fontWeight: 600,
  fontSize: 12,
  lineHeight: "16px",
  marginBottom: 8,
}))

export const CurrencyInputAmount = styled("div")<{ $color: string }>(
  ({ $color }) => ({
    fontSize: 20,
    lineHeight: "32px",
    fontWeight: 500,
    height: 32,
    color: $color,
  })
)

export const CurrencyInputRight = styled("div")<{ $color: string }>(
  ({ $color }) => ({
    width: 120,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    margin: 2,
    boxSizing: "border-box",
    color: $color,

    img: {
      width: "16px",
      height: "16px",
    },
  })
)

export const CurrencyInputValue = styled("div")(() => ({
  marginTop: 6,
  fontWeight: 400,
  fontSize: 12,
  lineHeight: "18px",
  textAlign: "center",
}))

export const RateBlock = styled("div")<{ $color: string }>(({ $color }) => ({
  padding: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "18px",
  position: "relative",
  color: $color,
}))

export const RateBlockCounter = styled("div")(() => ({
  display: "flex",
  alignItems: "center",

  span: {
    marginLeft: 8,
    fontSize: 12,
    color: "#808080",
  },
}))

export const MethodBlock = styled("div")(() => ({
  padding: "16px 16px 24px",
}))

export const MethodBlockLabel = styled("div")(() => ({
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 600,
  marginBottom: 8,
}))

export const MethodSelector = styled("div")<{ $bg: string }>(({ $bg }) => ({
  display: "flex",
  alignItems: "center",
  padding: 12,
  borderRadius: 4,
  background: $bg,

  img: {
    width: 30,
    height: 20,
  },

  svg: {
    minWidth: 20,
  },
}))

export const MethodSelectorLabel = styled("div")(() => ({
  padding: "0px 16px",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  width: "100%",
}))

export const BaseAmount = styled("div")<{ $color: string; $border: string }>(
  ({ $color, $border }) => ({
    margin: "0px 16px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14,
    borderBottom: `1px solid ${$border}`,
    paddingBottom: 12,

    span: {
      color: $color,
    },
  })
)

export const BaseAmountOpenLink = styled("div")<{ $color: string }>(
  ({ $color }) => ({
    color: $color,
  })
)

export const CommissionRaw = styled("div")<{ $color: string }>(
  ({ $color }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: $color,
    fontSize: 14,
    lineHeight: "20px",
    padding: "0 16px 12px",

    div: {
      display: "flex",
      alignItems: "center",
    },
  })
)

export const SubmitBtnWrapp = styled("div")(() => ({
  padding: 16,
}))

export const SubmitBtn = styled("div")<{ $bg: string; $color: string }>(
  ({ $bg, $color }) => ({
    fontSize: 16,
    lineHeight: "24px",
    background: $bg,
    padding: 12,
    textAlign: "center",
    borderRadius: 6,
    color: $color,
  })
)
